import { useEffect, useState } from 'react';

export function useRollingTextIndex(
  times: number,
  scrollProgress?: number,
): number {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (times <= 0 || scrollProgress === undefined) {
      return;
    }

    // scrollProgress (0-1)를 기반으로 index 계산
    // progress * times를 하면 0~times 범위가 됨
    const newIndex = Math.min(Math.floor(scrollProgress * times), times - 1);
    setIndex(newIndex);
  }, [scrollProgress, times]);

  return index;
}
